import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function CTAddOns() {
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-735">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-736">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-737">
          <h2 className="text-[28px] lg:text-[44px] uppercase text-white leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-738">
            ADD ONS TO MAXIMIZE YOUR RESULTS
          </h2>
          <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-739"></div>

          <p className="text-[#B0B0B0] italic text-base leading-[1.7] font-body max-w-[800px]" data-id="element-740">
            If you want to take your results to the next level, add on exosome
            microneedling to help improve texture and the appearance of
            overlying skin.
          </p>
        </AnimateOnScroll>

        <AnimateOnScroll data-id="element-741">
          <div className="max-w-[700px] mx-auto bg-[#111111] p-10 border-t-[3px] border-[#FF1493]" data-id="element-742">
            <h3 className="text-white text-2xl font-bold font-[Poppins,_sans-serif] mb-4" data-id="element-743">
              Exosomes
            </h3>
            <p className="text-[#B0B0B0] text-[15px] leading-[1.7] font-body" data-id="element-744">
              When combined, exosomes and microneedling create synergistic
              effects for radiant skin. Exosomes, rich in growth factors,
              cytokines, and regenerative molecules, penetrate deeply into the
              skin through the channels created by microneedling. This efficient
              delivery system directly targets the deeper layers of the skin,
              where cellular renewal and repair processes take place for
              stunning results.
            </p>
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}